<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>
    <div class="ViewDieselInfo ViewPromo__section">
      <div class="ViewDieselInfo__row">
        <div class="ViewDieselInfo__col">
          <div class="ViewDieselInfo__content">
            <h2 class="ViewDieselInfo__title">{{ name }}</h2>
            <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
            <div class="ViewDieselInfo__text app-typography">
              <h4>О компании:</h4>
              <p>
                Вот уже 15 лет специализируется на оптовых поставках
                нефтепродуктов, как на территории Нижегородской области, так и
                по территории России.
              </p>
              <p>
                Наша компания является активным участником Санкт-Петербургской
                Международной Товарно-Сырьевой биржи (СПбМТСБ) в секции
                Нефтепродукты.
              </p>
              <p>
                Мы осуществляем ежедневные закупки топлива, которое доставляется
                на основные нефтебазы Нижегородской области:
              </p>
              <ul class="unordered-list">
                <li>
                  Кудьминская нефтебаза (п. Кудьма); н/б Аэрофьюлз (Аэропорт г.
                  Нижний Новгород);
                </li>
                <li>н/б Пассажирнефтьсервис (г. Нижний Новгород)</li>
              </ul>
              <p>
                а также крупнейшие нефтебазы в регионах, с которыми заключены
                прямые договора хранения Топливная компания «РНК» заключила
                прямые договора поставки с заводами-изготовителями:
              </p>
              <ul class="unordered-list">
                <li>ООО «Лукойл-Центрнефтепродукт»;</li>
                <li>ООО «Татнефть-АЗС-Центр»;</li>
                <li>ООО «Татнефть-АЗС-Запад»;</li>
                <li>АО «Пензанефтепродукт» - филиал Роснефть г. Саранск;</li>
                <li>АО «РН-Ярославль»</li>
              </ul>
              <p>
                Для надежности и оперативной доставки топлива своим клиентам,
                наша компания имеет собственный парк бензовозов ёмкостью от 5 до
                30м3.
              </p>
            </div>
          </div>
        </div>
        <div class="ViewDieselInfo__col">
          <div class="ViewDieselInfo__advantages-wrapper">
            <ul class="ViewPromo__advantages">
              <li class="ViewPromo__advantage">
                <div class="ViewPromo__advantage-icon">
                  <app-svg-icon
                    name="iphone"
                    class="ViewPromo__advantage-icon-svg"
                  ></app-svg-icon>
                </div>
                <div class="ViewPromo__advantage-text">
                  <h4 class="ViewPromo__advantage-title">Данные поставщика</h4>
                  <p>
                    Телефон компании:<br />
                    <strong
                      ><a
                        href="tel:+78312621035"
                        class="ViewPromo__advantage-contact-link"
                        >+7(831) 262-10-35</a
                      ></strong
                    >
                  </p>
                  <p>
                    Адрес электронной почты:<br />
                    <strong
                      ><a
                        href="mailto:info@rosneftekom.ru"
                        class="ViewPromo__advantage-contact-link"
                        >info@rosneftekom.ru</a
                      ></strong
                    >
                  </p>
                  <!-- <a
                      class="ViewPromo__advantage-link"
                      href="/static/uploads/docs/Cкачать_реквизиты_пром-ресурс.doc"
                      download="Реквизиты ПромРесурс.doc"
                      >Cкачать реквизиты ПромРесурс</a
                    > -->
                </div>
              </li>
              <li class="ViewPromo__advantage">
                <div class="ViewPromo__advantage-icon">
                  <app-svg-icon
                    name="lock-pin"
                    class="ViewPromo__advantage-icon-svg"
                  ></app-svg-icon>
                </div>
                <div class="ViewPromo__advantage-text">
                  <h4 class="ViewPromo__advantage-title">Базисы отгрузки</h4>
                  <p>
                    Кудьминская нефтебаза (п. Кудьма); н/б Аэрофьюлз (Аэропорт
                    г. Нижний Новгород)<br />
                    н/б Пассажирнефтьсервис (г. Нижний Новгород)
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title:
      'Топливо оптом онлайн от поставщика РТК на платформе OPEN OIL MARKET',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1175,
    productId: 1949,
    name: 'ООО «РТК»',
    inn: '5260198591',
  }),
};
</script>
